import Axios, { Method as AxiosMethod, AxiosError, ResponseType } from "axios";

export interface HttpError {
    statusCode: number | undefined;
    data: any;
}

export type HttpMethod = "get" | "post" | "patch";
export type ContentType = "json" | "zip" | "pdf" | "text";

interface IContentTypeConfig {
    contentTypeHeader: string;
    acceptHeader: string;
    responseType?: ResponseType;
}

const contentTypeConfigMap: Record<ContentType, IContentTypeConfig> = {
    "json": {
        contentTypeHeader: 'application/json',
        acceptHeader: 'application/json',
    },
    "zip": {
        contentTypeHeader: 'application/zip',
        acceptHeader: 'application/zip',
        responseType: 'arraybuffer'
    },
    "pdf": {
        contentTypeHeader: 'application/pdf',
        acceptHeader: 'application/pdf',
        responseType: 'arraybuffer'
    },
    "text": {
        contentTypeHeader: 'text/plain',
        acceptHeader: 'text/plain',
    },
}

const httpClient = {
    makeRequest<TResponse, TResult>(
        url: string,
        method: HttpMethod,
        transformResponse: (response: TResponse) => TResult,
        requestData: any,
        contentType: ContentType
    ): Promise<TResult> {
        const contentConfig = contentTypeConfigMap[contentType];
        const axiosMethod = method as AxiosMethod;
        const acceptHeader = {
            ContentType: contentConfig.contentTypeHeader,
            Accept: contentConfig.acceptHeader
        };
        return new Promise((resolve, reject) => {
            Axios.request<TResponse>({
                method: axiosMethod,
                url: url,
                data: requestData,
                responseType: contentConfig.responseType,
                headers: { ...acceptHeader },
            }).then(response => {
                resolve(transformResponse(response.data));
            }).catch((error: AxiosError) => {
                reject({
                    statusCode: error?.response?.status,
                    data: error?.response?.data
                });
            });
        });
    }
};

export default httpClient;